import { DashboardLayouts } from "./dashboardLayoutTypes";

/* ============================================================================
 * DASHBOARD LAYOUT UTILITIES
 * Utility functions for dashboard layout system
 * ============================================================================ */

/**
 * Validate if an object is a valid DashboardLayouts structure
 */
export function isValidLayout(layout: unknown): layout is DashboardLayouts {
  if (!layout || typeof layout !== "object") return false;

  const requiredBreakpoints = ["lg", "md", "sm", "xs", "xxs"];
  return requiredBreakpoints.every((breakpoint) =>
    breakpoint in layout && Array.isArray(Reflect.get(layout, breakpoint)),
  );
}
